import { DropDown } from "../../types/DropDown";
import { DropDownActions, DropDownActionList } from "../actions/dropDownAction";

const initialState: DropDown[] = [];

export const dropDownReducer = (
  state: DropDown[] = initialState,
  action: DropDownActions,
): DropDown[] => {
  switch (action.type) {
    case DropDownActionList.ADD_DROPDOWN:
      return [...state, action.data];

    case DropDownActionList.EDIT_DROPDOWN:
      return state.map((item) =>
        item.id === (action.data.id ?? action.id) ? { ...action.data } : item,
      );

    case DropDownActionList.FETCH_DROPDOWN:
      return action.data;

    case DropDownActionList.DELETE_DROPDOWN:
      return state.filter((item) => item.id !== action.data);

    default:
      return state;
  }
};
